import { Message, MessageService } from 'primeng/api';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomMessageService {

  constructor(private _messageService: MessageService) { }


  add(message: Message): void {
    this._messageService.add(message);
  }
}
